import createTableStore from "ds/components/Table/store/useTableStore";

import { WORKER_POOLS_TABLE_COLUMNS_CONFIG, WORKER_POOLS_TABLE_STORAGE_KEY } from "./constants";

const useWorkerPoolsTableStore = createTableStore({
  storageKey: WORKER_POOLS_TABLE_STORAGE_KEY,
  config: WORKER_POOLS_TABLE_COLUMNS_CONFIG,
});

export default useWorkerPoolsTableStore;
